import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThemeService } from '@core/services/theme.service';
import { ValidatorComponent } from '@feature/survey-management/components/validator/validator.component';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorType } from '@shared/models/enums/validator-type.enum';
import { SingleSelect } from '@shared/models/question-types/single-select';
import { Subscription } from 'rxjs';
import { QuestionBaseComponent } from '../../question-base/question-base.component';

@Component({
  selector: 'app-satisfaction-meter',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    QuestionBaseComponent,
    ValidatorComponent,
  ],
  templateUrl: './satisfaction-meter.component.html',
  styleUrl: 'satisfaction-meter.component.scss',
})
export class SatisfactionMeterComponent implements OnInit, OnDestroy {
  @Input({ required: true }) question!: SingleSelect;
  @Input({ required: true }) control!: any;
  @Input() isFirstQuestion: boolean = false;
  svgurls = '/assets/icons/smileys/normal/smiley-';
  opacity = 'opacity-25';
  ValidatorType = ValidatorType;
  translationKeys = [
    {
      key: 'question.satisfaction.veryunsatisfied',
    },
    {
      key: 'question.satisfaction.unsatisfied',
    },
    {
      key: 'question.satisfaction.neutral',
    },
    {
      key: 'question.satisfaction.satisfied',
    },
    {
      key: 'question.satisfaction.verysatisfied',
    },
  ];

  private subscription: Subscription;

  constructor(
    private themeService: ThemeService,
    private cdr: ChangeDetectorRef,
  ) {
    this.subscription = this.themeService.highContrastChange.subscribe(
      (isHighContrast) => {
        this.opacity = isHighContrast ? 'opacity-65' : 'opacity-25';
        this.svgurls = isHighContrast
          ? '/assets/icons/smileys/high-contrast/smiley-'
          : '/assets/icons/smileys/normal/smiley-';
        this.cdr.markForCheck();
      },
    );
  }

  ngOnInit(): void {
    this.svgurls = this.themeService.highContrast
      ? '/assets/icons/smileys/high-contrast/smiley-'
      : '/assets/icons/smileys/normal/smiley-';
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  toggleSelection(value: string) {
    if (this.control.value === value) {
      this.control.setValue('');
      this.control.markAsUntouched();
    } else {
      this.control.setValue(value);
    }
  }

  handleKeydown(event: KeyboardEvent, value: string) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleSelection(value);
    }
  }
}
